export default {
    common: {
        home: 'Home',
        category: 'Category',
        product: 'Product',
        search: 'Search',
        about: 'About',
        loading: 'Loading...',
        error: 'Error',
        noData: 'No Data',
        contact: 'Contact Us',
        buy: 'Buy',
        price: 'Price',
        originalPrice: 'Original Price',
        hot: 'Hot',
        new: 'New',
        tags: 'Tags',
        exploreMore: 'Explore More',
        viewAll: 'View All',
        startShopping: 'Start Shopping',
        quickLinks: 'Quick Links',
        allRightsReserved: 'All Rights Reserved',
        close: 'Close',
        qr: 'QR Code',
        phone: 'Phone',
        products: 'products',
        share: 'Share',
        linkCopied: 'Link copied',
        backHome: 'Back Home',
        allCategories: 'All Categories',
        sortBy: 'Sort By',
        totalProducts: 'Total {count} products',
        timeRange: 'Time Range',
        allProducts: 'All Products'
    },
    nav: {
        home: 'Home',
        categories: 'Categories',
        hot: 'Hot Products',
        new: 'New Arrivals',
        about: 'About Us'
    },
    shop: {
        name: 'Shiguang',
        slogan: 'Yuxia\'s little broken shop',
        description: 'We provide a variety of software tools, system codes, platform members and other virtual and physical items'
    },
    category: {
        software: 'Software Tools',
        code: 'System Code',
        member: 'Platform Member',
        book: 'E-Books',
        custom: 'Custom Software',
        other: 'Other Products',
        description: 'Explore our curated digital products'
    },
    notice: {
        title: 'Announcements',
        welcome: 'Welcome to Our Shop',
        contact: 'Contact Information'
    },
    contact: {
        title: 'Contact Information',
        qq: 'QQ',
        wechat: 'WeChat',
        email: 'Email',
        phone: 'Phone',
        copy: 'Copy',
        copied: 'Copied to clipboard',
        copyFailed: 'Copy failed',
        buyTip: 'To purchase this product, please contact us through:',
        startChat: 'Start Chat',
        wechatTip: 'Please add WeChat friend to contact'
    },
    theme: {
        title: 'Theme Settings',
        light: 'Light Theme',
        dark: 'Dark Theme',
        techBlue: 'Tech Blue'
    },
    language: {
        title: 'Language Settings',
        chinese: '中文',
        english: 'English'
    },
    sort: {
        default: 'Default',
        priceAsc: 'Price: Low to High',
        priceDesc: 'Price: High to Low',
        nameAsc: 'Name: A-Z',
        nameDesc: 'Name: Z-A',
        newest: 'Newest',
        popularity: 'Most Popular'
    },
    filter: {
        byTag: 'Filter by Tag'
    },
    product: {
        description: 'Product Description',
        related: 'Related Products',
        notFound: 'Product Not Found',
        notFoundDesc: 'The product you are looking for may have been removed or does not exist',
        features: 'Features',
        specifications: 'Specifications',
        demo: 'Online Demo',
        demoImages: 'Product Demo Images',
        demoGallery: 'Product Demo Gallery',
        detailImages: 'Product Detail Images',
        viewDemo: 'View Demo',
        demoNotAvailable: 'Demo not available',
        noDetailImages: 'No detail images available',
        installGuide: 'Installation Guide',
        framework: 'Framework',
        database: 'Database',
        javaVersion: 'Java Version',
        frontend: 'Frontend',
        cache: 'Cache',
        security: 'Security',
        uiLibrary: 'UI Library',
        buildTool: 'Build Tool',
        typescript: 'TypeScript',
        supportedLanguages: 'Supported Languages',
        platforms: 'Platforms',
        memoryRequired: 'Memory Required',
        diskSpace: 'Disk Space',
        jdkSupport: 'JDK Support',
        inStock: 'In Stock',
        lowStock: 'Low Stock',
        outOfStock: 'Out of Stock',
        month: 'month'
    },
    search: {
        enterKeyword: 'Please enter search keywords',
        placeholder: 'Search product name, tags or description...',
        found: 'Found',
        noResults: 'No related products found',
        clearSearch: 'Clear Search',
        hotTags: 'Hot Tags',
        categories: 'Categories'
    },
    gallery: {
        gridView: 'Grid View',
        masonryView: 'Masonry View',
        slideshow: 'Slideshow',
        clickToPreview: 'Click to Preview',
        featured: 'Featured',
        noImages: 'No demo images available',
        imagePreview: 'Image Preview',
        previous: 'Previous',
        next: 'Next',
        download: 'Download',
        downloadSuccess: 'Download successful',
        downloadFailed: 'Download failed',
        resolution: 'Resolution',
        category: 'Category',
        screenshot: 'Screenshot',
        interface: 'Interface',
        management: 'Management',
        component: 'Component',
        visualization: 'Visualization',
        responsive: 'Responsive',
        pause: 'Pause',
        play: 'Play',
        defaultDescription: 'Product feature demo image',
        dashboardTitle: 'System Dashboard',
        dashboardDesc: 'Main dashboard interface display',
        loginTitle: 'Login Interface',
        loginDesc: 'User login page display',
        userTitle: 'User Management',
        userDesc: 'User management module interface',
        tableTitle: 'Data Table',
        tableDesc: 'Data table component display',
        formTitle: 'Form Interface',
        formDesc: 'Form component feature display',
        chartTitle: 'Chart Display',
        chartDesc: 'Data visualization charts',
        feature: 'Feature Display',
        demo: 'Demo Operation',
        mobileTitle: 'Mobile Adaptation',
        mobileDesc: 'Responsive design, perfect for mobile devices',
        defaultTitle: 'Demo Image {number}',
    },
    about: {
        title: 'About Us',
        subtitle: 'The remaining small broken store, a commodity service platform built by wild programmers',
        ourStory: 'Our Story',
        storyText1: 'We are a professional platform dedicated to product sales, dedicated to providing users with high-quality services.',
        storyText2: 'Since its establishment, we have always adhered to the business philosophy of "quality first, service first" to ensure that we provide users with genuine and reliable products.',
        storyText3: 'Our team consists of experienced technical experts and customer service personnel who can provide you with professional product consultation and after-sales service to make your purchasing experience more pleasant.',
        productsCount: 'Quality Products',
        categoriesCount: 'Categories',
        satisfaction: 'Customer Satisfaction',
        support: 'Online Support',
        ourServices: 'Our Services',
        service1Title: 'Genuine Guarantee',
        service1Desc: 'All products are genuine licensed to ensure your usage safety and legality',
        service2Title: 'Safe & Reliable',
        service2Desc: 'Advanced security technology to protect your personal information and transaction security',
        service3Title: 'Professional Service',
        service3Desc: 'Professional customer service team provides 7×24 hours consultation and technical support',
        service4Title: 'Quality Assurance',
        service4Desc: 'Strict quality control process ensures every product meets high quality standards',
        ourAdvantages: 'Our Advantages',
        advantage1Title: 'Selected Products',
        advantage1Desc: 'We carefully select every product to ensure we provide you with the highest quality digital products',
        advantage2Title: 'Fast Delivery',
        advantage2Desc: 'Perfect order processing system ensures you can quickly get your purchased products',
        advantage3Title: 'Reasonable Price',
        advantage3Desc: 'Direct cooperation with manufacturers, removing intermediaries, providing you with the most competitive prices',
        contactUs: 'Contact Us',
        contactDesc: 'If you have any questions or need help, please contact our customer service team at any time',
        feature1: '100% Genuine Guarantee',
        feature2: 'Professional Technical Support',
        feature3: 'Quick Response Service',
        feature4: 'Quality User Experience'
    },
    categories: {
        description: 'Browse our carefully categorized products to quickly find what you need',
        empty: 'No categories available',
        noProducts: 'No products in this category'
    },
    hot: {
        description: 'Discover the most popular products that users love and choose',
        empty: 'No hot products available'
    },
    new: {
        description: 'Check out our latest products and be the first to experience new releases',
        empty: 'No new products available'
    },
    time: {
        all: 'All Time',
        lastWeek: 'Last Week',
        lastMonth: 'Last Month',
        last3Months: 'Last 3 Months'
    },
    view: {
        grid: 'Grid View',
        list: 'List View',
        mode: 'View Mode',
        compact: 'Compact',
        detailed: 'Detailed',
        compactTip: 'Space Saving',
        detailedTip: 'Hover Expand'
    },
    categoryNav: {
        all: 'All',
        searchCategory: 'Search Categories',
        searchPlaceholder: 'Search categories...',
        expandAll: 'Expand All Categories',
        collapseAll: 'Collapse All Categories',
        resetView: 'Reset View',
        foundCategories: 'Found {count} categories'
    }
}
